<div class="popup-header">

  <div class="popup-header-title"> {{ title }} </div>
  <!-- <app-close-icon (closeIcon)="close()"></app-close-icon> -->

</div>
